import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

export default function Experience({ lang }: Props) {
  const { t } = useTranslation('experience');
  const tc = useTranslation('common').t;
  const summaryItems = t('summary.items', { returnObjects: true }) as string[];

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          {t('date')} &nbsp;|&nbsp; <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('mainPage')}</Link>
          &nbsp;|&nbsp; <a href="https://github.com/microbusiness" target="_blank" rel="noopener noreferrer">{tc('github')}</a>
        </p>
        <hr />

        <p>{t('intro')}</p>

        <h4>{t('beginning.title')}</h4>
        <p>{t('beginning.text')}</p>

        <h4>{t('itCenter.title')}</h4>
        <p>{t('itCenter.text')}</p>

        <h4>{t('business.title')}</h4>
        <p>{t('business.text')}</p>

        <h4>{t('internet.title')}</h4>
        <p>{t('internet.text')}</p>

        <h4>{t('cotrip.title')}</h4>
        <p>{t('cotrip.text')}</p>

        <h4>{t('develop.title')}</h4>
        <p>{t('develop.text')}</p>

        <h4>{t('freelance.title')}</h4>
        <p>{t('freelance.text')}</p>

        <h4>{t('searching.title')}</h4>
        <p>{t('searching.text')}</p>

        <hr />
        <h4>{t('summary.title')}</h4>
        <ul>
          {summaryItems.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </Layout>
  );
}
